import { Component, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent, DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { GeneratedQrCodesDTO, ZoneDTO } from 'src/app/base/models/models.swagger.generated';
import { GenerateQrCodeDetailsService } from './generate-qr-code-details.service';
import { TranslateModule } from '@ngx-translate/core';

import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';

@Component({
    selector: 'app-generate-qr-code-details',
    templateUrl: './generate-qr-code-details.component.html',
    styleUrls: ['./generate-qr-code-details.component.scss'],
    imports: [DialogModule, YesNoGroupButtonComponent, ReactiveFormsModule, TooltipModule, TranslateModule]
})
export class GenerateQrCodeDetailsComponent {
  @ViewChild('generateQrCodeDialog') public generateQrCodeDialog: DialogComponent;

  public zone: ZoneDTO;
  public isStickerModeControl: FormControl<boolean> = new FormControl<boolean>(true);
  public parkingSpaceNumberControl: FormControl<string> = new FormControl<string>("");

  constructor(
    private qrService: GenerateQrCodeDetailsService,
  ) { }

  public openDialog(zone: ZoneDTO) {
    this.zone = zone;
    this.generateQrCodeDialog.show();
  }

  public closeDialog() {
    this.generateQrCodeDialog.hide();
    this.zone = null;
    this.isStickerModeControl.setValue(true);
    this.parkingSpaceNumberControl.setValue("");
  }

  public generateQrCode() {
    this.qrService.generateQrCode(this.zone.id, this.isStickerModeControl.value, this.parkingSpaceNumberControl.value).subscribe(dto => {
      const link = this.createInvisibleDownloadLink(dto);
      link.click();
      this.closeDialog();
    });
  }

  private createInvisibleDownloadLink(generatedQrCodesDTO: GeneratedQrCodesDTO) {
    const source = `data:application/octet-stream;base64,${generatedQrCodesDTO.contentBase64}`;
    const link = document.createElement('a');
    link.href = source;
    link.download = `${generatedQrCodesDTO.zipName}`;
    return link;
  }

}
